<template>
    <div class="survey">
        <van-nav-bar
                fixed
                title="现场考察评分"
                left-arrow
                @click-left="$router.go(-1)">
        </van-nav-bar>
        <div class="hhb-view">
            <detail-view v-model="info" :attrs="attrs" :opts="opts"/>
        </div>
    </div>
</template>

<script>
    import DetailView from "@/components/detail/index";

    export default {
        name: "survey",
        components: {DetailView},
        data() {
            return {
                info: {},
                opts: {},
                attrs: [
                    {
                        head: {
                            title: '现场考察评分'
                        },
                        body: [
                            {type: 'images', name: 'businessLicense', title: '营业执照：', valueKey: 'dataUrl'},
                            {type: 'text', name: 'operatingIncome', title: '主要营业收入：'},
                            {type: 'text', name: 'liabilities', title: '资产负债率：'},
                            {type: 'text', name: 'qualification', title: '资质证明：'},
                            {type: 'text', name: 'honor', title: '荣誉奖励：'},
                            {type: 'text', name: 'investigator', title: '考察人：'},
                            {type: 'text', name: 'visitDate', title: '考察日期：'},
                            {type: 'text', name: 'investigation', title: '考察结果：'},
                            {type: 'text', name: 'surveyScore', title: '考察评分：'},
                            {type: 'images', name: 'phones', title: '考察照片：', valueKey: 'dataUrl'},
                            {
                                type: 'download',
                                name: 'reports',
                                title: '补充材料：',
                                valueKey: 'dataUrl',
                                labelKey: 'dataTitle'
                            }
                        ]
                    }
                ]
            };
        },
        methods: {
            requestData() {
                this.info = {};
                this.$toast.loading('加载中...');
                this.request({
                    url: "/v1.0/Project/getSiteVisitScore",
                    method: "get",
                    params: {
                        projectId: this.getId,
                    },
                }).then((res) => {
                    this.info = res.data;
                    this.$toast.clear();
                }).catch(() => {
                    this.$toast.clear();
                });
            }
        },
        computed: {
            getId() {
                return this.$route.query.id;
            }
        },
        created() {
            this.requestData();
        }
    }
</script>

<style lang="scss" scoped>
</style>